import "./components/people.ts";
import "./components/header.ts";
import "./components/slider.ts";
